import qs from "qs";
import request from "@/utils/request";

export function getActivityInfo() {
  return request({
    url: "/activity/v1/getActivityInfo",
    method: "get",
  });
}

export function getRankTotalApi(params) {
    return request({
        url: "/activity/v1/getRankTotal",
        method: "get",
        params
    });
}

export function getRankWeekApi(params) {
    return request({
        url: "/activity/v1/getRankWeek",
        method: "get",
        params
    });
}

export function getRankUploadApi(params) {
    return request({
        url: "/activity/v1/getRankUpload",
        method: "get",
        params
    });
}

export function getAvUserInfoApi(params) {
    return request({
        url: "/avUser/v1/getAvUserInfo",
        method: "post",
        headers: { "Content-Type": "application/json;charset=UTF-8" },
        params
    });
}

export function getInvitedListApi(params) {
    return request({
        url: "/avUser/v1/getInvitedList",
        method: "post",
        headers: { "Content-Type": "application/json;charset=UTF-8" },
        params
    });
}

export function getLuckyTimesApi() {
    return request({
        url: "/luckyDraw/v1/getTimes",
        method: "post",
        headers: { "Content-Type": "application/json;charset=UTF-8" },
    });
}

export function getPrizeListApi() {
    return request({
        url: "/luckyDraw/v1/getPrizeList",
        method: "get",
    });
}

export function luckyStartApi() {
    return request({
        url: "/luckyDraw/v1/start",
        method: "post",
        headers: { "Content-Type": "application/json;charset=UTF-8" },
    });
}

export function getLatestRecordApi() {
    return request({
        url: "/luckyDraw/v1/getLatestRecord",
        method: "get",
    });
}

export function getPrizeRecordApi(params) {
    return request({
        url: "/luckyDraw/v1/getPrizeRecord",
        method: "post",
        headers: { "Content-Type": "application/json;charset=UTF-8" },
        params
    });
}

export function getPrizeApi(params) {
    return request({
        url: "/luckyDraw/v1/getPrize",
        method: "post",
        headers: { "Content-Type": "application/json;charset=UTF-8" },
        params
    });
}

export function getMoneyRecordApi(params) {
    return request({
        url: "/avUser/v1/getMoneyRecord",
        method: "post",
        headers: { "Content-Type": "application/json;charset=UTF-8" },
        params
    });
}
